"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serializeQuery = serializeQuery;
function serializeQuery(obj) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(obj)) {
    if (value === null || value === undefined || value === false) continue;
    if (typeof value === "string") {
      if (value.trim() === "") continue;
      params.append(key, value);
      continue;
    }
    if (value === true) {
      params.append(key, "true");
      continue;
    }
    throw new TypeError(`Unsupported value type for key "${key}": ${String(value)}`);
  }
  return params.toString();
}